import { Component, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';


import { L10n, setCulture, setCurrencyCode, loadCldr } from '@syncfusion/ej2-base';

import * as italianLocale from '@syncfusion/ej2-locale/src/it.json';
import * as numberingSystems from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json';
import * as caGregorian from '@syncfusion/ej2-cldr-data/main/it/ca-gregorian.json';
import * as numbers from '@syncfusion/ej2-cldr-data/main/it/numbers.json';
import * as timeZoneNames from '@syncfusion/ej2-cldr-data/main/it/timeZoneNames.json';
import { ToastComponent, ToastModule } from '@syncfusion/ej2-angular-notifications';
import { ToastService } from './services/toast.service.ts';

import * as currencies from '@syncfusion/ej2-cldr-data/main/it/currencies.json';
import * as currencyData from '@syncfusion/ej2-cldr-data/supplemental/currencyData.json';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, ToastModule],
})
export class AppComponent implements OnInit {
    
    @ViewChild('toastmessage') toast: ToastComponent = {} as ToastComponent; // Prende quello dell'HTML

    constructor(private toastService: ToastService) {}

    ngOnInit(): void {
        // 1. Carica i formati internazionali
        loadCldr(numberingSystems, caGregorian, numbers, timeZoneNames, currencies, currencyData);

        // 2. Carica le traduzioni dei testi della Grid
        L10n.load({
            'it': italianLocale.it
        });

        // 3. Imposta la cultura globale su italiano
        setCulture('it');
        setCurrencyCode('EUR');
    }

    ngAfterViewInit(): void {
        // Diamo il telecomando del toast al servizio
        this.toastService.registerToast(this.toast);
    }
}